module.exports = __webpack_public_path__ + "844aa3c972a6ec17a71e86cde597dceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/alipay.png
// module id = 317
// module chunks = 0